/**
 * Which history event type an item field change is recorded under.
 *
 * Each tracked field maps to the event that names it. A field with no event of
 * its own is recorded as a generic field change (details.field says which) --
 * never as a title change, which is what an unmapped field used to fall into.
 */
export const ITEM_FIELD_EVENT_TYPES: Readonly<Record<string, string>> = {
  title: 'item_title_updated',
  description: 'item_description_updated',
  itemCategory: 'item_category_updated',
  altitudeLevel: 'item_altitude_updated',
  dedupeStatus: 'item_dedupe_updated',
  duplicateOfId: 'item_dedupe_updated',
  parentItemId: 'item_parent_updated',
  tags: 'item_tags_updated',
  desiredOutcome: 'item_description_updated',
  acceptanceCriteria: 'item_description_updated',
  readyForRanking: 'item_marked_complete',
  attributes: 'attribute_schema_attached',
  metadata: 'attribute_schema_attached',
  exit_status: 'item_exit_status_changed',
  work_type: 'item_work_type_updated',
  launch_type: 'item_launch_type_updated',
  investment_type: 'item_investment_type_updated',
  // Written by the item page's Strategy and Patterns sections (recordItemFieldChange).
  objectiveLink: 'item_objective_link_changed',
  goalLink: 'item_goal_link_changed',
  customTypeList: 'item_custom_type_changed',
  patternOverride: 'item_pattern_override_changed',
};

export const GENERIC_ITEM_FIELD_EVENT = 'item_field_updated';

export function itemFieldEventType(field: string): string {
  return ITEM_FIELD_EVENT_TYPES[field] ?? GENERIC_ITEM_FIELD_EVENT;
}
